import axios from 'axios';

export const send = axios.create({
  baseURL: 'https://ri-ege.ru/lk/2021/service/',
  crossDomain: true,
  withCredentials: true
});